// extracted by mini-css-extract-plugin
module.exports = {"email":"contact_email__5Svuc","number":"contact_number___wK7V","contact_whole":"contact_contact_whole__CXmDg","contact_parent":"contact_contact_parent__nQjxK"};